import { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import checkboxOnImage from 'assets/checkbox-on.png';
import checkboxOffImage from 'assets/checkbox-off.png';
import { updatePersonalInfo } from 'lib/api/auth';
import { toast } from 'react-hot-toast';
import client, { serviceClient } from 'lib/api/client';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const Th = styled.th`
  border: 1px solid #000;
  padding: 8px;
  font-weight: 500;
`;

const Td = styled.td`
  border: 1px solid #000;
  padding: 8px;
  vertical-align: middle;
  height: 100px;
`;

const PrivacyCollectionTable = () => {
  return (
    <Table>
      <thead>
        <tr>
          <Th>수집항목</Th>
          <Th>목적</Th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <Td>성명, 이동전화번호, 유선전화번호, 이메일 주소, 주소</Td>
          <Td>서비스 가입 및 장비 설치</Td>
        </tr>
        <tr>
          <Td>
            성명, 이동전화번호, 유선전화번호, 이메일 주소, 주소, IP 주소, 계정,
            계약번호, 고객 요청 사항 및 상담이력(상담통화 내역)
          </Td>
          <Td>
            서비스 안내/제공, 서비스 유지보수를 포함한 CS 등 고객 경험 향상,
            시스템 성능 관리 등을 위한 시스템 보안
          </Td>
        </tr>
      </tbody>
    </Table>
  );
};

const Container = styled.div`
  width: 900px;
  margin: 0 auto;
  font-weight: 500;
  padding-bottom: 30px;
`;

export const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { refreshToken, accessToken, username, userLevel, userType, userId } =
    useSelector(({ auth }) => auth);
  const [isOver14, setIsOver14] = useState(false);
  const [isAgree, setIsAgree] = useState(null);
  const isActive = isOver14 && isAgree !== null;

  const handleSubmit = () => {
    if (!isAgree) {
      toast.error(
        <div>
          개인정보 수집∙이용에 동의하지 않는 경우 <br />
          서비스를 이용할 수 없습니다.
        </div>,
      );

      navigate('/');

      return;
    }
    (async () => {
      try {
        await updatePersonalInfo(userId);

        toast.success('확인하였습니다!');

        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('username', username);
        localStorage.setItem('userLevel', userLevel);
        localStorage.setItem('userType', userType);
        localStorage.setItem('userId', userId);

        client.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${accessToken}`;
        serviceClient.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${accessToken}`;

        navigate('/admin');
      } catch {
        toast.error('서버 오류가 발생했습니다.');
      }
    })();
  };

  useEffect(() => {
    if (!userId) {
      navigate('/');
    }
  }, [userId, navigate]);

  return (
    <Container>
      <h1>개인정보 수집∙이용에 대한 안내</h1>

      <p>
        캡스 스마트냉난방은 서비스 제공을 위하여 필요한 최소한의 범위 내에서
        개인정보를 수집∙이용하고자 합니다.
      </p>

      <p>
        정상적인 서비스 이용을 위해서는 개인정보 수집∙이용에 대한 동의가
        필요합니다.
      </p>

      <p>
        <span style={{ color: '#152E70', marginRight: 4 }}>(필수)</span>
        <span style={{ marginRight: 6 }}>캡스 스마트냉난방 이용약관</span>
        <a
          href="/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#152E70', textDecoration: 'underline' }}
        >
          보기
        </a>
      </p>

      <p>
        <span style={{ color: '#152E70', marginRight: 4 }}>(필수)</span>
        <span>개인정보 수집항목 및 이용 목적</span>
      </p>

      <PrivacyCollectionTable />

      <div
        onClick={() => setIsOver14(prev => !prev)}
        style={{
          marginTop: 20,
          display: 'flex',
          alignItems: 'center',
          userSelect: 'none',
          cursor: 'pointer',
        }}
      >
        <img
          src={isOver14 ? checkboxOnImage : checkboxOffImage}
          alt="checkbox"
          style={{ marginRight: 6 }}
        />
        <span style={{ color: '#152E70', marginRight: 4 }}>(필수)</span>
        <span>만 14세 이상입니다.</span>
      </div>

      <p>위 개인정보 수집∙이용에 동의하시겠습니까?</p>

      <div
        style={{
          display: 'flex',
          gap: 60,
          fontWeight: 'bold',
        }}
      >
        <div
          onClick={() => setIsAgree(true)}
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
          <img
            src={isAgree === true ? checkboxOnImage : checkboxOffImage}
            alt="checkbox"
            style={{ marginRight: 6 }}
          />
          <span>동의합니다.</span>
        </div>

        <div
          onClick={() => setIsAgree(false)}
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
          <img
            src={isAgree === false ? checkboxOnImage : checkboxOffImage}
            alt="checkbox"
            style={{ marginRight: 6 }}
          />
          <span>동의하지 않습니다.</span>
        </div>
      </div>

      <div style={{ color: '#aaaaaa', marginTop: 26 }}>
        *개인정보 수집∙이용에 대한 동의를 거부할 수 있습니다.
        <br />
        *단, 필수 항목 동의 거부 시에는 서비스 이용이 제한될 수 있습니다.
        <br />
        *만 14세 미만 사용자는 본 서비스를 이용할 수 없습니다.
      </div>

      <button
        onClick={handleSubmit}
        disabled={!isActive}
        style={{
          backgroundColor: isActive ? '#152E70' : '#aaaaaa',
          width: 160,
          height: 40,
          marginTop: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: isActive ? 'pointer' : 'not-allowed',
          color: '#fff',
          border: 'none',
        }}
      >
        확인
      </button>
    </Container>
  );
};
